module.exports = __webpack_public_path__ + "img/maluly-jr-advogados-logo.31f2c71f.webp";